import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimTypeDealerGroupAutomationRule.Save.IRequest;
type Params = Api.Core.ClaimTypeDealerGroupAutomationRule.Save.IParams;
type Response = Api.Core.ClaimTypeDealerGroupAutomationRule.Save.IResponse;
type Headers = Api.Core.ClaimTypeDealerGroupAutomationRule.Save.IHeaders;
const saveApiClaimTypeDealerGroupAutomationRulePath =
  '/api/DealerManagement/ClaimTypeDealerGroupAutomationRule/:claimTypeId';
export default async function claimTypeDealerGroupAutomationRuleSaveApi(
  body: Request,
  params: Params
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(saveApiClaimTypeDealerGroupAutomationRulePath, {
      claimTypeId: params?.claimTypeId || body?.claimTypeId || body?.claimTypeAutomationRule?.claimTypeId,
    }),
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    body: body,
    headers: getDefaultHeaders(),
  });
}
